<template>
    <!--    <div class="containerMask"></div>-->
    <!--    <div class="icon iconxinxitishi">44</div>-->
    <!--    <span class=" icon iconjinbi" style="color: #4AFD88; ;font-size:14px;">55</span>-->
    <van-row class="head">
        <van-col
            class="menu"
            v-on:click="
                octopus.router.jump(
                    octopus.passport.typeID == 1
                        ? '/APP/Campus/Location/TeacherLocation'
                        : '/main/app/campus/login'
                )
            "
        >
            <div class="icon icona-5biao-dingwei-01"></div>
            <div class="text">定位</div>
        </van-col>
        <van-col
            class="menu"
            v-on:click="octopus.router.jump('/APP/Campus/Trajectory/Page')"
        >
            <div class="icon icona-5biao-guiji-01"></div>
            <div class="text">轨迹</div>
        </van-col>
           <van-col class="menu" v-on:click="octopus.router.jump('/APP/Campus/Enclosure/Page?tsp=' + new Date().getTime())">
             <div class="icon icona-5biao-dianziweilan-01"></div>
             <div class="text">
               电子围栏
             </div>
           </van-col>
        <van-col
            class="menu"
            v-on:click="
                octopus.router.jump(
                    octopus.passport.typeID == 2
                        ? '/APP/Campus/Location/StudentLocation'
                        : '/APP/Campus/Location/TeacherLocation'
                )
            "
        >
            <div class="icon icondaohang1"></div>
            <div class="text">导航</div>
        </van-col>
        <van-col
            class="menu"
            v-on:click="octopus.router.jump('/APP/Campus/Whole/Page')"
        >
            <!--        <van-col class="menu">-->
            <div class="icon icona-5biao-gengduo-01"></div>
            <div class="text" @click="onNavigation">全部</div>
        </van-col>
    </van-row>
</template>

<script>
export default {
    name: "oHeadToolsEngine" /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */,
    data() {
        return {
            octopus: this.$parent.octopus,
        };
    },
    created: function () {
        // this.init();
    },
    updated: function () {
        this.octopus.tips.debug("[AppMenuEngine执行了updated事件。");
    },
    // 活动事件，写在这里的好处是不管是第一次创建还是后退回来，都会触发这个事件
    // 比较典型的就是列表组件，返回的时候往往是需要刷新的。
    activated: function () {
        this.load();
    },
    // 组件停用时，也就是切换出去的时候，需要注意的是，AppMenuEngine组件切换出去，不允许缓存，需要释放到初始状态，以便于下次进来。
    deactivated: function () {
        // this.destroyData();
        this.octopus.tips.debug("AppMenuEngine执行了deactivated事件。");
    },
    computed: {
        // 如果cellData数据发生了改变,则触发这个事件。
        changeCell: function () {
            return this.source.id;
        },
        changePage: function () {},
    },
    methods: {
        // 测试vant调用摄像头
        load: function () {},
    },
    watch: {},
    props: ["changed"],
};
</script>



// WEBPACK FOOTER //
// src/components/APP/Campus/Assembly/HeadTools.vue